import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { UsersSelectors } from '../../../Redux/modules/users/selectors';
import styles from './TeamsContainer.module.less';
import Teams from '../components/Teams';
import { AppSelectors } from '../../../Redux/modules/app/selectors';
import { UsersActions } from '../../../Redux/modules/users/actions';
import { AppActions } from '../../../Redux/modules/app/actions';
import Tabs from '../../Tabs/Tabs';
import InsightsParagraph from '../../Users/components/InsightsParagraph';

const TeamsContainer = (props) => {
  const actions = [
    {
      id: 1,
      name: 'RENAME_TEAM',
      title: gettext('Rename team'),
      onClick: () => {
        props.clickedRenameTeamButton();
      },
      permission: () => {
        return true;
      },
    },
    {
      id: 2,
      title: gettext('Delete team'),
      name: 'DELETE_TEAM',
      style: { color: '#d7446f' },
      onClick: () => {
        props.clickedDeleteTeamButton();
      },
      permission: () => {
        return true;
      },
    },
  ];
  return (
    <div className={styles.container}>
      <div className={styles.header}>Users and teams</div>
      {props.usersData.search_status && !props.hasApiContext && (
        <InsightsParagraph
          availableSubscriptions={props.availableSubscriptions}
          totalSubscriptions={props.totalSubscriptions}
          isTrial={props.isTrial}
        />
      )}
      <Tabs
        tabs={[
          { title: gettext('Users'), link: 'manage-users/users/' },
          { title: gettext('Teams'), link: 'manage-users/teams/' },
        ]}
      />
      <div className={styles.section}>
        <div className={styles.sectionDiv}>
          <Teams
            teams={props.teams}
            clickedCreateTeamButton={props.clickedCreateTeamButton}
            isTeamManagement={props.isTeamManagement}
            onEnableTeamManagement={props.onEnableTeamManagement}
            onDisableTeamManagement={props.onDisableTeamManagement}
            disableTeamManagementModalOpen={props.disableTeamManagementModalOpen}
            createTeamModalOpen={props.createTeamModalOpen}
            clickedDisableTeamManagementButton={props.clickedDisableTeamManagementButton}
            clickedCloseModalButton={props.clickedCloseModalButton}
            clickedRenameTeamButton={props.clickedRenameTeamButton}
            clickedDeleteTeamButton={props.clickedDeleteTeamButton}
            actions={actions}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isTeamManagement: AppSelectors.isTeamManagementSelector(state),
    disableTeamManagementModalOpen: UsersSelectors.disableTeamManagementModalSelector(state),
    createTeamModalOpen: UsersSelectors.createTeamModalSelector(state),
    teams: UsersSelectors.teamsSelector(state),
    usersData: UsersSelectors.usersDataSelector(state),
    availableSubscriptions: UsersSelectors.availableSubscriptionsSelector(state),
    totalSubscriptions: UsersSelectors.totalSubscriptionSelector(state),
    isTrial: UsersSelectors.isTrialSelector(state),
    hasApiContext: AppSelectors.hasApiContextSelector(state),
  };
};

const mapDispatchToProps = {
  onEnableTeamManagement: AppActions.enableTeamManagement,
  onDisableTeamManagement: AppActions.disableTeamManagement,
  clickedCreateTeamButton: UsersActions.clickedCreateTeamButton,
  clickedDisableTeamManagementButton: UsersActions.clickedDisableTeamManagementButton,
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  clickedRenameTeamButton: UsersActions.clickedRenameTeamButton,
  clickedDeleteTeamButton: UsersActions.clickedDeleteTeamButton,
};

TeamsContainer.propTypes = {
  teams: PropTypes.array,
  usersData: PropTypes.object,
  clickedCreateTeamButton: PropTypes.func,
  clickedDisableTeamManagementButton: PropTypes.func,
  isTeamManagement: PropTypes.bool,
  onEnableTeamManagement: PropTypes.func,
  onDisableTeamManagement: PropTypes.func,
  disableTeamManagementModalOpen: PropTypes.bool,
  createTeamModalOpen: PropTypes.bool,
  clickedCloseModalButton: PropTypes.func,
  clickedRenameTeamButton: PropTypes.func,
  clickedDeleteTeamButton: PropTypes.func,
  availableSubscriptions: PropTypes.number,
  totalSubscriptions: PropTypes.number,
  isTrial: PropTypes.bool,
  hasApiContext: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(TeamsContainer);
